import { QuestionBase } from './question-base.model';

export class FlagsQuestion extends QuestionBase<string> {
    controlType = 'flags';
    type: string;
    name: string;
    popover: string;
    format: string;
    class_conditions: any;
    grid_color_text: any;
    view_required: boolean;
    visible: boolean = true;
    flag: any;
    flag_condition: any;
    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
        this.name = options['name'] || '';
        this.popover = options['popover'] || '';
        this.format = options['format'] || "";
        this.visible = options['visible'] != undefined ? options['visible'] : true;
        this.class_conditions = options['class_conditions'] == undefined ? false : options['class_conditions'];
        this.grid_color_text = options['grid_color_text'] == undefined ? false : options['grid_color_text'];
        this.view_required = options['view_required'] || false;
        this.flag = options['flag'] || false;
        this.flag_condition = options['flag_condition'] || false;
        this.label = options['label'] || '';
    }
}